module.exports = __webpack_public_path__ + "img/smiley_0.0b87d587.png";